import defaultState from './defaultState'

export default {
  toggleSidebar(state) {
    state.isSidebarShown = !state.isSidebarShown
  },
  setMainTitle(state, title) {
    state.mainTitle = title
  },
  reset(state) {
    Object.assign(state, defaultState())
  },
  setRecordPreviewRecordModalConfig(state, value) {
    state.recordPreviewRecordModalConfig = {
      ...state.recordPreviewRecordModalConfig,
      ...value,
    }
  },
  setRecordPreviewRecordModalConfigDefault(state) {
    state.recordPreviewRecordModalConfig = {
      isShow: false,
      recordId: null,
    }
  },
}
